import { configureStore } from "@reduxjs/toolkit";

import counterReducer from "./counterSlice";
import dashboardEventsReducer from "./dashboardEventsSlice";
import initialDateReducer from "./initialDateSlice";
import menuReducer from "./menuSlice";

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        menu: menuReducer,
        initialDate: initialDateReducer,
        dashboardEvents: dashboardEventsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
